const learnMoreFormHome = document.getElementById('learn_more_contact_form');

learnMoreFormHome.addEventListener('submit', (event) => {
  event.preventDefault(); // Prevent default form submission behavior
  const formDataHome = new FormData(event.target);

  const hpFieldHome = formDataHome.get('company');
  if (hpFieldHome && hpFieldHome.trim() !== '') {
    return;
  }

  const jsonData = {
    utm_source: getUrlParameter('utm_source'),
  };

  formDataHome.delete('company');

  formDataHome.forEach((value, key) => {
    jsonData[key] = value;
  });

  sendFormDataHome(jsonData)
    .then(() => {
      // Redirect user after successful form submission
      window.location.href = 'https://courses.avocademy.com/is-ux-for-me';
    })
    .catch((error) => {
      console.error('Error sending form data:', error);
    });
});

async function sendFormDataHome(json) {
  try {
    const response = await fetch('https://hooks.zapier.com/hooks/catch/13914929/37b10om/', {
      method: 'POST',
      body: JSON.stringify(json),
    });
    if (!response.ok) {
      throw new Error('Failed to submit form data');
    }
  } catch (error) {
    throw new Error('Error sending form data:', error);
  }
}

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#"]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
